import { useState, useEffect } from "react";
import { CiBarcode, CiCircleRemove } from "react-icons/ci";
import QRCode from "qrcode";
import RSModal from "../ui/RSModal";

/**
 * QR code content rendered inside RSModal.
 * RSModal passes `setShow` automatically via cloneElement.
 *
 * QR codes are generated client-side from the plain-text referral code string,
 * matching the same pattern used for gas station QR codes in this project.
 * No backend API is needed — the referral code is simply encoded as plain text.
 */
const QRContent = ({ referralCode, setShow }) => {
	const [qr, setQr] = useState("");

	useEffect(() => {
		if (!referralCode) return;

		QRCode.toDataURL(
			referralCode,
			{
				width: 800,
				margin: 2,
				color: {
					dark: "#335383FF",
					light: "#EEEEEEFF",
				},
			},
			(err, url) => {
				if (!err) setQr(url);
			}
		);
	}, [referralCode]);

	const imageStyle = {
		display: "block",
		width: "280px",
		height: "280px",
		margin: "1.5rem auto 0.5rem",
	};

	return (
		<div className='pos-rel' style={{ width: "400px", padding: "40px" }}>
			<CiCircleRemove
				className='cursor-pointer transition hover-color-secondary'
				onClick={() => setShow(false)}
				style={{
					position: "absolute",
					top: "10px",
					right: "10px",
					fontSize: "32px",
				}}
			/>
			<h4 className='color-primary'>Referral QR Code</h4>
			<p style={{ fontSize: "13px", color: "#8f8f8f", marginTop: "4px" }}>
				Share this code to refer new customers
			</p>
			<section
				style={{
					border: "solid 1px #e5e7eb",
					borderRadius: "10px",
					padding: "10px",
					marginTop: "16px",
				}}>
				<div className='flex center-center'>
					<div className='t-a-c'>
						{qr ? (
							<div>
								<img src={qr} alt='Referral QR Code' style={imageStyle} />
								<div
									className='flex center-center'
									style={{ paddingBottom: "12px" }}>
									<span
										style={{
											background: "#2980B918",
											color: "#2980B9",
											fontSize: "18px",
											fontWeight: 800,
											letterSpacing: "4px",
											padding: "8px 20px",
											borderRadius: "8px",
										}}>
										{referralCode}
									</span>
								</div>
							</div>
						) : (
							<p
								style={{
									padding: "40px 0",
									color: "#8f8f8f",
									fontSize: "13px",
								}}>
								Loading QR Code...
							</p>
						)}
					</div>
				</div>
			</section>
		</div>
	);
};

/**
 * QRCodeModal
 * Drop-in component: renders a small barcode icon that opens the QR modal.
 */
const QRCodeModal = ({ referralCode }) => {
	if (!referralCode) return null;

	return (
		<RSModal
			selector={
				<CiBarcode
					className='cursor-pointer'
					style={{ height: "22px", width: "22px", color: "inherit" }}
					title='View Referral QR Code'
				/>
			}
			content={<QRContent referralCode={referralCode} />}
		/>
	);
};

export default QRCodeModal;
